import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from '@reduxjs/toolkit';
import { redirectToLoginPath } from '@/lib/utils/router';

const isRTKApiError = (action: any): boolean =>
  action?.meta?.baseQueryMeta && action?.meta?.requestId;

const isAuthError = (action: any): boolean => action?.payload?.status === 401;

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action) && isRTKApiError(action)) {
      // An HTTP 401 error occurred, redirect to login page
      if (isAuthError(action)) {
        redirectToLoginPath();
      }
    }

    return next(action);
  };
